import React from 'react'
import ModalBasic from '../../component/ModalBasic'
import MultiSelectDropdown from '../../../components/dropdown/MultiSelectDropdown'
import { AgGridReact } from "ag-grid-react";
import TextInput from '../../../components/UIComponent/TextInput';

const itemColdefs = [
    {
        field: "drawingNo",
        headerName: "Drawing no",
        minWidth: window.innerWidth * 0.09,
        flex: 0.9,
        filter: true,
    },
    {
        field: "itemType",
        headerName: "Item type",
        minWidth: window.innerWidth * 0.1,
        flex: 1,
        filter: true,
    },
    {
        field: "itemName",
        headerName: "Item details",
        minWidth: window.innerWidth * 0.2,
        flex: 2,
        filter: true,
    },
    {
        field: "quantity",
        headerName: "Quantity",
        minWidth: window.innerWidth * 0.08,
        flex: 0.8,
        filter: true,
    },
    {
        field: "remarks",
        headerName: "Remarks",
        minWidth: window.innerWidth * 0.08,
        flex: 0.8,
        filter: true,
    },
];

export const PurchaseInquiryPopup = (props) => {
    return (
        <ModalBasic
            id="purchse-inquiry"
            classParams="!w-[75%] overflow-y-auto"
            modalOpen={props.isModalOpen}
            setModalOpen={props.setOpenModel}
        >
            <div className='input-fields p-[30px]'>
                <span className="text-blue text-[16px] font-semibold">Purchase inquiry details</span>
                <div className='item-grp grid grid-cols-4 gap-2.5 mt-3 mb-2 pb-[8px] border-b border-slate-200 items-start'>
                    <div className='input-grp'>
                        <label>Purchase indent no</label>
                        <TextInput type='text'
                            id='piNo' name='piNo'
                            value={props.purchaseObject.piNo}
                            handleChange={(event) => props.handleChangeForPurchase(event, 'piNo')}
                            className={props.validState?.error?.piNo !== undefined ? "error" : ""}
                            disabled
                        />
                    </div>
                    <div className='input-grp'>
                        <label>PI date</label>
                        <TextInput type='date'
                            id='piDate' name='piDate'
                            value={props.purchaseObject.piDate}
                            handleChange={(event) => props.handleChangeForPurchase(event, 'piDate')}
                            className={props.validState?.error?.piDate !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp col-span-2'>
                        <label>Auth. employee</label>
                        {/* <MultiSelectDropdown
                            drpIdentity="Select material"
                            options={props.purchaseObject.EmployeeList}
                            value={props.purchaseObject.idEmployee ? props.purchaseObject.EmployeeList.find(x => x.value === props.purchaseObject.idEmployee) : 0}
                            onChange={(event) =>
                                props.handleChangeForDropdown(event, "idEmployee", 'purchaseObject')
                            }
                            className={props.validState?.error?.idEmployee !== undefined ? "error" : ""}
                        /> */}
                        <TextInput type='text'
                            id='usp_Users' name='usp_Users'
                            value={props.usp_Users.find(x => x.globalUserID === props.globalUserID)?.userName || ''}
                            disabled={true}
                        // handleChange={(event) => props.handleChangeForWork(event, 'personName')}
                        // className={props.validState?.error?.personName !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp col-span-2'>
                        <label>Select work order</label>
                        <MultiSelectDropdown
                            drpIdentity="Select supplier"
                            options={props.purchaseObject.workOrderList}
                            value={props.purchaseObject.idWorkOrder ? props.purchaseObject.workOrderList.find(x => x.value === props.purchaseObject.idWorkOrder) : 0}
                            onChange={(event) =>
                                props.handleChangeForDropdown(event, "idWorkOrder", 'purchaseObject')
                            }
                            className={props.validState?.error?.idWorkOrder !== undefined ? "error" : ""}
                        />

                    </div>
                    <div className='btn-grp flex gap-2.5 col-span-2 mt-5'>
                        <button className="save-btn btns py-[10px] px-[20px] h-[40px]" onClick={() => props.generate()} >Generate</button>
                    </div>

                </div>
                <span className="text-blue text-[16px] font-semibold">Item details</span>
                <div className='item-grp grid grid-cols-4 gap-2.5 mt-3 mb-2 pb-[8px] border-b border-slate-200 items-start'>
                    <div className='input-grp'>
                        <label>Drawing no</label>
                        <TextInput type='text'
                            id='drawingNo' name='drawingNo'
                            value={props.itemObject.drawingNo}
                            handleChange={(event) => props.handleChangeForItem(event, 'drawingNo')}
                            className={props.validState?.error?.drawingNo !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Select type</label>
                        <MultiSelectDropdown
                            drpIdentity="Select material"
                            options={props.itemObject.TypeList}
                            value={props.itemObject.idType ? props.itemObject.TypeList.find(x => x.value === props.itemObject.idType) : 0}
                            onChange={(event) =>
                                props.handleChangeForDropdown(event, "idType", 'itemObject')
                            }
                            className={props.validState?.error?.idType !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp col-span-2'>
                        <label>Item name</label>
                        <MultiSelectDropdown
                            drpIdentity="Select priority"
                            options={props.itemObject.ItemList}
                            value={props.itemObject.idItem ? props.itemObject.ItemList.find(x => x.value === props.itemObject.idItem) : 0}
                            onChange={(event) =>
                                props.handleChangeForDropdown(event, "idItem",)
                            }
                            className={props.validState?.error?.idItem !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Quantity</label>
                        <TextInput type='number'
                            id='quantity' name='quantity'
                            value={props.itemObject.quantity}
                            handleChange={(event) => props.handleChangeForItem(event, 'quantity')}
                            className={props.validState?.error?.quantity !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Remarks</label>
                        <TextInput type='text'
                            id='remarks' name='remarks'
                            value={props.itemObject.remarks}
                            handleChange={(event) => props.handleChangeForItem(event, 'remarks')}
                            className={props.validState?.error?.remarks !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='btn-grp flex gap-2.5 col-span-2 mt-5'>
                        {/* <button className="save-btn btns py-[10px] px-[20px] h-[40px]" onClick={() => props.insert("Insert")}>Insert</button>
                        <button className="edit-btn btns py-[10px] px-[20px] h-[40px]">Clear</button>
                        <button className="delete-btn btns py-[10px] px-[20px] h-[40px]">Delete</button> */}
                        {props.itemObject.keyId > 0 ?
                            <>
                                <button className="save-btn btns py-[10px] px-[20px] h-[40px]" onClick={() => props.insert("Update")}>Update</button>
                                <button className="delete-btn btns py-[10px] px-[20px] h-[40px]" onClick={() => props.deleteItem(props.itemObject.keyId)}>Delete</button>
                            </>
                            :
                            <button className="save-btn btns py-[10px] px-[20px] h-[40px]" onClick={() => props.insert("Insert")}>Insert</button>
                        }
                    </div>
                </div>
                <div className="register-table h-[40vh]">
                    <div className="table-inner h-full">
                        <AgGridReact
                            rowData={props.itemRowData}
                            columnDefs={itemColdefs}
                            onCellClicked={props.handleCellClickItemList}
                            onGridReady={props.onGridReady}
                            overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                            overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                        />
                    </div>
                </div>
                <div className='btn-grp flex gap-2.5 mt-5'>
                    <button className="update-btn btns" onClick={() => props.submit()} disabled={props.isSaving}>Save</button>
                    {/* <button className="print-btn btns">Print</button>
                    <button className="edit-btn btns">Preview</button> */}
                    <button className="delete-btn btns" onClick={() => props.close()}>Cancel</button>
                </div>
            </div>

        </ModalBasic>
    )
}